// extracted by mini-css-extract-plugin
export default {"container":"EventFeedback_container__pq6Vz","title":"EventFeedback_title__GHjrr","buttonContainer":"EventFeedback_buttonContainer__PSMzJ"};